import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
  scrollToSection,
  scrollToTop
} from '../../../utils/scroll';

import {
  handleSectionNavigation
} from '../../../utils/navigation';
import './Footer.css';
import logo from '../../../assets/images/logo.png';
import { FaFacebook } from "react-icons/fa6";
import { RiInstagramFill } from "react-icons/ri";
import { IoLogoWhatsapp } from "react-icons/io";
import { FiMapPin } from "react-icons/fi";
import { BsTelephone } from "react-icons/bs";
import { MdOutlineEmail } from "react-icons/md";
import { FaRegClock } from "react-icons/fa6";
import { MdLockOutline } from "react-icons/md";
import { MdChevronRight } from "react-icons/md";

const Footer = () => {
  const navigate = useNavigate();

  return (
    <footer className="footer">

      <div className="footer-topbar">
        <div className="footer-topbar-container">

          <a
            className="footer-topbar-logo"
            href="/"
            onClick={(e) =>
              handleSectionNavigation(
                e,
                'início',
                navigate,
                scrollToSection
              )
            }
          >
            <img src={logo} alt="Grupo Egel" />
          </a>

          <div className="footer-trust">
            <MdLockOutline className="footer-trust-icon" />
            <span>Site confiável 100% seguro</span>
          </div>

          <div className="social-icons footer-topbar-socials">
            <a
              href="https://www.facebook.com/grupo.egel"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
            >
              <FaFacebook className="icon" />
            </a>

            <a
              href="https://www.instagram.com/grupo.egel/"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
            >
              <RiInstagramFill className="icon" />
            </a>

            <a
              href="https://wa.me/554999957692"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
            >
              <IoLogoWhatsapp className="icon" />
            </a>
          </div>
        </div>
      </div>

      <div className="footer-container">
        <div className="footer-grid">

          <div className="footer-section">
            <h4 className="section-title">Links Rápidos</h4>

            <ul className="footer-links">
              <li>
                <a
                  href="/"
                  onClick={(e) =>
                    handleSectionNavigation(
                      e,
                      'início',
                      navigate,
                      scrollToSection
                    )
                  }
                >
                  <MdChevronRight className="link-icon" />
                  Início
                </a>
              </li>

              <li>
                <a
                  href="/"
                  onClick={(e) =>
                    handleSectionNavigation(
                      e,
                      'serviços-faq',
                      navigate,
                      scrollToSection
                    )
                  }
                >
                  <MdChevronRight className="link-icon" />
                  Dúvidas
                </a>
              </li>

              <li>
                <a
                  href="/"
                  onClick={(e) =>
                    handleSectionNavigation(
                      e,
                      'sobre',
                      navigate,
                      scrollToSection
                    )
                  }
                >
                  <MdChevronRight className="link-icon" />
                  Sobre nós
                </a>
              </li>

              <li>
                <a
                  href="/"
                  onClick={(e) =>
                    handleSectionNavigation(
                      e,
                      'contato',
                      navigate,
                      scrollToSection
                    )
                  }
                >
                  <MdChevronRight className="link-icon" />
                  Fale conosco
                </a>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="section-title">Serviços</h4>

            <ul className="footer-links">
              <li>
                <a
                  href="/"
                  onClick={(e) =>
                    handleSectionNavigation(
                      e,
                      'serviços',
                      navigate,
                      scrollToSection
                    )
                  }
                >
                  <MdChevronRight className="link-icon" />
                  Operações
                </a>
              </li>

              <li>
                <Link
                  to="/termos-servico"
                  onClick={() => setTimeout(() => scrollToTop(false), 100)}
                >
                  <MdChevronRight className="link-icon" />
                  Termos de Serviço
                </Link>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="section-title">Contato</h4>

            <ul className="contact-info">
              <li className="contact-item">
                <div className="icon-box contact-item-container">
                  <FiMapPin />
                </div>
                <span>
                  Rua Marechal Deodoro, 198, Sala 1 - Lages, SC
                </span>
              </li>

              <li className="contact-item">
                <div className="icon-box contact-item-container">
                  <BsTelephone />
                </div>
                <span>+55 (49) 9995-7692</span>
              </li>

              <li className="contact-item">
                <div className="icon-box contact-item-container">
                  <MdOutlineEmail />
                </div>
                <span>fernando@egelemprestimos.com.br</span>
              </li>

              <li className="contact-item">
                <div className="icon-box contact-item-container">
                  <FaRegClock />
                </div>
                <span>
                  Seg-Sex: 8:30h às 12h e 13:30h às 18:00h
                </span>
              </li>
            </ul>
          </div>

        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>&copy; 2023 Egel. Todos os direitos reservados.</p>
            <p className="cnpj">CNPJ: 21.945.243/0001-72</p>
          </div>
        </div>
      </div>

    </footer>
  );
};

export default Footer;